<script>
import store from '@state/store'
import Layout from '@layouts/loggedin.vue'
import { authComputed } from '@state/helpers'
import CopyToClipboard from 'vue-copy-to-clipboard'

const WIDGET_TYPE = [
  {
    type: 'bars',
    label: 'Tracker Bars Only',
    img: 'https://dev.kyndhub.com/images/bars.png',
  },
  {
    type: 'feed',
    label: 'Bars and Feed',
    img: 'https://dev.kyndhub.com/images/bars_feed.png',
  },
  {
    type: 'event',
    label: 'Event Listings',
    img: 'https://dev.kyndhub.com/images/events.png',
  },
]
export default {
  components: {
    Layout,
    CopyToClipboard,
  },
  data() {
    return {
      widgetData: WIDGET_TYPE,
      type: 'bars',
      url: '',
      withFilters: false,
      withCalendar: false,
      widget: '',
    }
  },
  computed: {
    ...authComputed,
  },
  methods: {
    chooseType(item) {
      this.type = item.type
      this.widget = ''
    },
    postWidget() {
      if (!this.url) {
        return
      }
      const params = { type: this.type, url: this.url }
      if (this.type === 'event') {
        if (this.withFilters) {
          Object.assign(params, { withFilters: true })
        }
        if (this.withCalendar) {
          Object.assign(params, { withCalendar: true })
        }
      }
      store
        .dispatch('adminWidgets/postWidget', params)
        .then((data) => {
          this.widget = encodeURIComponent(data.widget)
        })
        .catch(() => alert('Something went wrong.'))
    },
    copyCode() {
      alert('Copied!')
    },
  },
}
</script>

<template>
  <Layout>
    <div class="bg-white px-7.5 pt-4 pb-6 mb-6 text-xl">
      <span class="">Widget</span>
      <span class="breadcrumb-separator">></span>
      <span class="text-blue">Create a Widget</span>
    </div>

    <div class="bg-white mt-8 mx-7.5 px-10 pt-12 pb-16 rounded-xl shadow-lg">
      <div class="border-b-2 border-blue-lighter pb-16 mb-12">
        <h3 class="text-2xl text-blue-darker mb-20 text-center">
          Here are your display options
        </h3>
        <div class="flex justify-around items-stretch">
          <div
            v-for="item in widgetData"
            :key="item.type"
            class="text-center cursor-pointer"
            @click="() => chooseType(item)"
          >
            <label>{{ item.label }}</label>
            <div
              :class="[
                'border-2 rounded-xl mt-4 py-3 w-45 h-64',
                item.type === type ? 'border-gray' : 'border-white',
              ]"
            >
              <img :src="item.img" class="mx-auto" />
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="type === 'event'"
        class="border-b-2 border-blue-lighter pb-16 mb-10"
      >
        <h3 class="text-2xl text-blue-darker mb-20 text-center">
          Optional Event Widget Features
        </h3>
        <div class="flex justify-around">
          <div>
            <BaseInputChoice
              id="withFilters"
              v-model="withFilters"
              type="checkbox"
              name="withFilters"
              label="Include Event Filters"
              class="flex-col"
            >
              <template v-slot:icons>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 477.875 477.875"
                  height="50"
                  fill="#069BD7"
                  class="block mb-4 mx-auto"
                  style="enable-background:new 0 0 477.875 477.875;"
                >
                  <g>
                    <path
                      d="M460.804,0H17.071C7.645,0,0.004,7.641,0.004,17.067V102.4c0.001,4.836,2.054,9.445,5.649,12.681l165.018,148.514V460.8c-0.004,9.426,7.633,17.07,17.059,17.075c2.651,0.001,5.266-0.615,7.637-1.8l102.4-51.2c5.786-2.891,9.441-8.806,9.438-15.275V263.595l165.018-148.48c3.604-3.243,5.658-7.866,5.649-12.715V17.067C477.871,7.641,470.23,0,460.804,0z M443.737,94.805L278.72,243.285c-3.604,3.243-5.657,7.866-5.649,12.715v143.053l-68.267,34.133V256c-0.001-4.836-2.054-9.445-5.649-12.68L34.137,94.805V34.133h409.6V94.805z"
                    />
                  </g>
                </svg>
              </template>
            </BaseInputChoice>
          </div>
          <div>
            <BaseInputChoice
              id="withCalendar"
              v-model="withCalendar"
              type="checkbox"
              name="withCalendar"
              label="Include Events Calendar"
              class="flex-col"
            >
              <template v-slot:icons>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 1000 957.8"
                  height="50"
                  fill="#069BD7"
                  class="mb-4 mx-auto"
                >
                  <title>Kyndhub_Events_Icon</title>
                  <path
                    d="M975.44,151.77H783.87V46.68a24.56,24.56,0,0,0-49.08,0V151.82H265.21V46.68a24.56,24.56,0,0,0-49.08-2q0,1,0,2V151.82H24.56A24.56,24.56,0,0,0,0,176.34v778A24.56,24.56,0,0,0,24.56,978.9H975.44A24.56,24.56,0,0,0,1000,954.34h0v-778a24.57,24.57,0,0,0-24.56-24.57Zm-24.56,778H49.08V460.2h901.8Zm0-518.66H49.08V200.9h167v61.87a24.56,24.56,0,0,0,49.08,0V200.9H734.74v61.87a24.57,24.57,0,0,0,49.09,0V200.9h167Z"
                    transform="translate(0 -21.1)"
                  />
                </svg>
              </template>
            </BaseInputChoice>
          </div>
        </div>
      </div>

      <div class="w-1/3 mx-auto pt-10">
        <BaseInputText
          id="url"
          v-model="url"
          label="What group information would you like to embed?"
          placeholder="Enter your group URL here"
        />
      </div>

      <div class="text-center mt-20">
        <div class="text-3xl mb-4">That’s all we need!</div>
        <div v-if="!widget">
          <button
            class="button primary-button h-9.5 leading-relax text-lg rounded-small-button px-4"
            @click="postWidget"
          >
            Generate Code
          </button>
        </div>
        <div v-else class="flex">
          <input
            readonly
            :value="decodeURIComponent(widget)"
            class="w-4/5 border border-gray rounded-xl rounded-r-none px-4"
          />
          <CopyToClipboard :text="decodeURIComponent(widget)" @copy="copyCode">
            <button
              class="button primary-button h-9.5 leading-relax text-lg rounded-small-button rounded-l-none px-4"
            >
              Copy Code
            </button>
          </CopyToClipboard>
        </div>
      </div>
    </div>
  </Layout>
</template>
